import React, { useRef } from 'react';

import { Layout } from 'Deer/intent/components/Layout/Layout';
import { EmployeeRosterIntentDropdown } from 'screens/admin/EmployeeRoster/EmployeeRosterIntentDropdown';
import Employees from 'screens/admin/Employees';
import EmployeesRevamp from 'screens/admin/EmployeesRevamp';
import { checkSettingsRevampEmployeeRosterEnabled } from 'utils/helpers/featureFlags';

const EmployeeRosterIntent = () => {
  const gridRef = useRef();
  return (
    <Layout
      Filters={
        <EmployeeRosterIntentDropdown
          breadcrumbs={{
            items: [
              {
                label: 'Company Settings',
                to: '',
              },
            ],
            page: {
              label: 'Employee Roster',
              to: '',
            },
          }}
          isEmployeeListPage
          gridRef={gridRef}
        />
      }
    >
      {checkSettingsRevampEmployeeRosterEnabled() ? <EmployeesRevamp gridRef={gridRef} /> : <Employees />}
    </Layout>
  );
};

export default EmployeeRosterIntent;
